import React, {useState} from 'react';
import {IModule} from "../../../../models/IModule";
import styles from './EditModule.module.css'
import {EnumModuleTypes} from "../../../../enums/EnumModuleTypes";
import TextEditor from "../../../../components/Utils/TextEditor/TextEditor";
import {EnumLanguage} from "../../../../enums/EnumLanguage";
import LayoutContentWrapper from "../../../../components/Layout/LayoutContentWrapper/LayoutContentWrapper";
import {UIText} from "../../../../enums/UIText/UIText";
import Button, {
    EnumButtonType,
    EnumButtonWeight,
    EnumColors
} from "../../../../components/Utils/Buttons/Buttons/Buttons";
import EditModuleImage from "./EditModuleImage/EditModuleImage";
import {useAppDispatch} from "../../../../hooks/redux";
import {sendModuleDataThunk} from "../../../../store/actions/ModulesActions";

interface IProps {
    module?: IModule,
    type: EnumModuleTypes,
    setIsOpenEditModule: (status: boolean) => void
}

const EditModule = (props: IProps) => {


    //Data for send
    const [title_ru, setTitle_ru] = useState<string>(props.module ? props.module.title[EnumLanguage.ru] : '')
    const [title_en, setTitle_en] = useState<string>(props.module ? props.module.title[EnumLanguage.en] : '')
    const [price, setPrice] = useState<any>(props.module ? props.module?.price : 0)
    const [description_ru, setDescription_ru] = useState<string>(props.module
                                                                    ? props.module.description[EnumLanguage.ru]
                                                                    : '')
    const [description_en, setDescription_en] = useState<string>(props.module
                                                                    ? props.module.description[EnumLanguage.en]
                                                                    : '')
    const [images, setImages] = useState([]);

    //Controls
    const [editLanguage, setEditLanguage] = useState<EnumLanguage>(EnumLanguage.ru)
    const [isLoading, setIsLoading] = useState<boolean>(false)






    const dispatch = useAppDispatch()


    const sendModuleDataHandler = async () => {

        const id = props.module ? props.module.id : null

        const data = {
            id,
            title_ru,
            title_en,
            price: Number(price),
            description_ru,
            description_en,
            type: props.type
        }

        const form = new FormData();

        // @ts-ignore
        const file = images[0] ? images[0].file : null

        if (file) {
            form.append('image', file);
        }
        form.append('data', JSON.stringify({...data}));

        const isNewModule = !Boolean(id)

        setIsLoading(true)
        dispatch(sendModuleDataThunk({
            form,
            setIsOpenEditModule: props.setIsOpenEditModule,
            isNewModule})).finally(() => {
            setIsLoading(false)
        })

    }

    const cancelEditModule = () => props.setIsOpenEditModule(false)

    return (
        <LayoutContentWrapper>
                <div className={styles.formWrapper}>
                    <div className={styles.languageButtonsWrapper}>
                        <Button
                            color={editLanguage === EnumLanguage.ru ? EnumColors.gold : EnumColors.black}
                            type={EnumButtonType.filled}
                            onClick={() => setEditLanguage(EnumLanguage.ru)}>{'Русская версия'}</Button>
                        <Button
                            color={editLanguage === EnumLanguage.en ? EnumColors.gold : EnumColors.black}
                            type={EnumButtonType.filled}
                            onClick={() => setEditLanguage(EnumLanguage.en)}>{'Английская версия'}</Button>
                    </div>

                    <div className={styles.headerWrapper}>

                        {editLanguage === EnumLanguage.ru && (<input
                                className={styles.titleInput}
                                type="text"
                                placeholder={UIText.inputs.placeholder.writeTitle[EnumLanguage.ru]}
                                value={title_ru}
                                onChange={(e) => setTitle_ru(e.target.value)}/>
                        )}

                        {editLanguage === EnumLanguage.en && (<input
                                className={styles.titleInput}
                                type="text"
                                placeholder={UIText.inputs.placeholder.writeTitle[EnumLanguage.ru]}
                                value={title_en}
                                onChange={(e) => setTitle_en(e.target.value)}/>
                        )}

                        {props.type === EnumModuleTypes.additional && <input
                            className={styles.priceInput}
                            placeholder={UIText.inputs.placeholder.writePrice[EnumLanguage.ru]}
                            type="number"
                            value={price}
                            onChange={(e) => setPrice(e.target.value)}/>}
                    </div>
                    <div className={styles.imageWrapper}>
                        <EditModuleImage currentImage={props.module?.images?.path} images={images} setImages={setImages}/>
                    </div>
                    <div className={styles.descriptionWrapper}>
                        {editLanguage === EnumLanguage.ru &&
                            <TextEditor setValue={setDescription_ru} value={description_ru}/>}
                        {editLanguage === EnumLanguage.en &&
                            <TextEditor setValue={setDescription_en} value={description_en}/>}
                    </div>

                    <div className={styles.buttonsWrapper}>
                        <Button
                            color={EnumColors.white}
                            weight={EnumButtonWeight.slim}
                            type={EnumButtonType.filled}
                            onClick={cancelEditModule}>
                            {UIText.actions.back[EnumLanguage.ru]}
                        </Button>
                        <Button
                            loading={isLoading}
                            disabled={isLoading}
                            onClick={sendModuleDataHandler}
                            color={EnumColors.gold}
                            weight={EnumButtonWeight.slim}
                            type={EnumButtonType.filled}
                        >{props.module ? UIText.actions.save[EnumLanguage.ru] : UIText.actions.create[EnumLanguage.ru]}
                        </Button>
                    </div>
                </div>
        </LayoutContentWrapper>
    );
};

export default EditModule;